import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { defaultRadiusType, radiusTypes } from "@/utils/constants";
import { Dropdown } from "@/components/common/inputs";
import { setPickupRadius, setDeliveryRadius } from "@/state/searchInputSlice";
import { useQuery } from "@/utils/query";
import { useLocation } from "react-router";
import { setCurrentSearch } from "@/state/currentSearchSlice";
import { cn } from "@/utils/css";
import { SwitchButton } from "@/components/search/SwitchButton";

export const RadiusInput = ({ type = "pickup", visible, className, handleSwitch }) => {
    const dispatch = useDispatch();
    const { pickupRadius, deliveryRadius } = useSelector((state) => state.searchInput);
    const radius = type === "pickup" ? pickupRadius : deliveryRadius;
    const { pickupRadius: queryPickupRadius, deliveryRadius: queryDeliveryRadius } = useQuery();
    const queryRadius = useMemo(() => {
        return type === "pickup" ? queryPickupRadius : queryDeliveryRadius;
    }, [queryPickupRadius, queryDeliveryRadius]);
    const location = useLocation();
    const setRadius = type === "pickup" ? setPickupRadius : setDeliveryRadius;

    const handleSetRadius = (id) => {
        dispatch(setRadius(radiusTypes.find((t) => t.id === id)));
    };

    useEffect(() => {
        const initialRadius = queryRadius ? radiusTypes.find((t) => t.id === queryRadius) : defaultRadiusType;
        dispatch(setRadius(initialRadius));
        dispatch(setCurrentSearch({ [`${type}Radius`]: initialRadius }));
        // Clearing done via SearchInputs clear
    }, [location.pathname, queryRadius]);

    return (
        <>
            <Dropdown
                className={cn(
                    "w-[112px] mb-1 md:mb-0 rounded-l-none",
                    {
                        "mr-1": visible && type === "delivery",
                        "w-[0px] p-0": !visible,
                    },
                    className,
                )}
                items={radiusTypes}
                value={radius}
                setValue={handleSetRadius}
                label="Radius"
                minWidth={visible ? 112 : 0}
                listWidth={visible ? 144 : 0}
            />
            {handleSwitch && (
                <div className="w-6 h-[64px] bg-cm-p-surface-container flex items-center justify-center">
                    <SwitchButton onClick={handleSwitch} />
                </div>
            )}
        </>
    );
};
